export default "__VITE_ASSET__674cc993__"